import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { getMember } from '../../../selectors/member/get-member';
import { assertIsMemberSignedIn } from '../../../utils/assert-is-member-signed-in';
export const updateMemberPhoto = async (photoFormData) => {
    const member = getMember();
    assertIsMemberSignedIn(member, 'Cannot update member photo');
    const createdMemberPhoto = await ocapiClient.instance.v1.loyalty.members.update.setPhoto(photoFormData);
    runInAction(() => {
        member.photo = createdMemberPhoto.memberPhoto;
    });
};
